<template>
	<div class="advantage">
		<div class="content">
			<div class="list flex-row">
				<div class="item flex-column" v-for="(item, index) in list">
					<div>{{ item.text1 }}</div>
					<div>
						<div>{{ item.text2 }}</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			list: [
				{
					text1: '100+',
					text2: '药企选择',
				},
				{
					text1: '80000+',
					text2: 'CSO应用',
				},
				{
					text1: '400000+',
					text2: '推广代表使用',
				},
			]
		};
	}
};
</script>

<style lang="scss" scoped>
.list {
	width: $global-content-width;
	margin: 0 auto;
	justify-content: space-around;
	align-items: center;
}
.item:hover {
	transform: scale(1.03);
}

.list > div:last-child {
	margin-right: 0px;
}
.item {
	transition: all 0.3s;
	align-items: center;
	justify-content: space-between;
	width: 248px;
	height: 130px;
	background: linear-gradient(180deg, #F4F6F8 0%, #FEFEFF 100%);
	box-shadow: 0px 2px 4px 0px rgba(212,212,212,0.5);
	border-radius: 4px;
	border: 2px solid #FFFFFF;
	> :first-child {
		margin-top: 23px;
		font-size: 34px;
		font-weight: 600;
		color: #333333;
		line-height: 50px;
		
	}
	> :last-child {
		margin-bottom: 22px;
		font-size: 16px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #333333;
		line-height: 25px;
	}
}
.title {
	margin: 0 auto;
	text-align: center;
	height: 45px;
	font-size: 32px;
	font-family: PingFangSC-Semibold, PingFang SC;
	font-weight: 600;
	color: #333333;
	line-height: 45px;
	margin-bottom: 69px;
}
.advantage {
	margin-top: 105px;
	background-color: white;
}
</style>
